import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import interceptor from './utils/interceptor'
import VImageInput from 'vuetify-image-input';
import VueTimers from 'vue-timers'
import moment from 'moment'
import vuetify from './plugins/vuetify';
import Vuesax from 'vuesax'
import VueChatScroll from 'vue-chat-scroll'
import Lingallery from 'lingallery';
import ProductZoomer from 'vue-product-zoomer'

Vue.config.productionTip = false
import 'vuesax/dist/vuesax.css'
import 'material-icons/iconfont/material-icons.css';
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css';

import { init as initApm } from 'elastic-apm-js-base';

import 'vuesax/dist/vuesax.css' 

Vue.use(Vuesax)
Vue.use(VueTimers)
Vue.use(VueChatScroll)
Vue.use(ProductZoomer)

Vue.component(VImageInput.name, VImageInput);
Vue.component('lingallery', Lingallery);

Vue.filter('currency', value => {
  return 'R$ ' + value.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
})

Vue.filter('celular', function (phone) {
  return phone.replace(/[^0-9]/g, '')
              .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
}); 

Vue.filter('documento', (documentId, documentType) => {
  documentId = typeof documentId != 'string' ? documentId.toString() : documentId;
  if (documentType == 'J') {
    documentId = documentId.padStart(14, '0');
    documentId = documentId.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    documentId = documentId.padStart(11, '0');
    documentId = documentId.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  return documentId;
});

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  return value
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
})


Vue.filter('porcentagem', value => {
  value = Math.floor(value)
  value = value + '%'
  return value
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
})

Vue.filter('formatDateTime', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm')
  }
})

Vue.filter('formatTime', function (value) {
  if (value) {
    return moment(String(value)).format('HH:mm')
  }
})

interceptor()
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
